import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { closeDialog } from "@shared/store/dialog.duck";
import Dialog from '@shared/ui/molecules/Dialog';
import DialogHeader from '@shared/dialogs/DialogHeader';
import { LoadingOverlay } from '@shared/ui/molecules/LoadingOverlay';
import { PrimaryButton } from '@shared/ui/atoms/buttons/PrimaryButton';
import styled from "styled-components";
import { TeamEntity } from '@shared/models/team.models';
import { Tag } from '@shared/models/tags.models';
import { selectAllTags } from "@shared/store/userTags.duck";
import TeamMultiSelect from '@shared/ui/organisms/team-drop-down-list/TeamMultiSelect';
import { updateDeskOwnershipsForWorkgroups } from "@features/desks/services/DeskOwnershipService";
import { clearSelectedDeskIds, selectSelectedDeskIds } from "../ducks/manageDesks.duck";
import { successNotification } from "@shared/store/notification.duck";
import { fetchDesks } from "@features/desks/store/deskBooking.duck";
import { selectSelectedOffice } from "../../../store/officeView.duck";

export function AssignDesksToWorkgroupDialog() {
  const dispatch = useDispatch();
  const allTags = useSelector(selectAllTags);
  const [selectedWorkGroups, setWorkGroups] = useState<Tag[]>([]);
  const [loading, setLoading] = useState(false);
  const selectedDeskIds = useSelector(selectSelectedDeskIds);
  const selectedOffice = useSelector(selectSelectedOffice);

  const close = () => {
    dispatch(closeDialog())
  };

  const updateTagClick = async () => {
    setLoading(true);
    try {
      await updateDeskOwnershipsForWorkgroups(selectedDeskIds, selectedWorkGroups);
      dispatch(clearSelectedDeskIds());
      if (selectedOffice) {
        dispatch(fetchDesks(selectedOffice.id));
      }
      dispatch(successNotification('Desks assigned to workgroup'))
      close();
    } finally {
      setLoading(false);
    }
  };

  const selectWorkgroup = (teams: TeamEntity[], workgroups: Tag[]) => {
    setWorkGroups(workgroups)
  }

  return (
    <DialogWrapper isOpen={true} onClose={close} showLogo={true}>
      <DialogHeader title="manage-desks-sidebar.assign-desks-to-workgroup" />

      {loading && <LoadingOverlay />}

      <TeamMultiSelect onSelect={selectWorkgroup}
                       disabled={loading}
                       workGroups={allTags}
                       selectedWorkGroups={selectedWorkGroups} />

      <PrimaryButton disabled={loading}
                     fullWidth={true}
                     click={updateTagClick}
                     style={{marginTop: 'auto'}}
                     text="button.save-changes" />
    </DialogWrapper>
  )
}

const DialogWrapper = styled(Dialog)<any>`
  &.dialog {
    max-width: 100%;
    min-height: 410px;
  }
  .dialog__contentContainer, .dialog__content {
    width: 500px;
    min-height: 500px;
  }
  .dialog__content {
    display: flex;
    flex-direction: column;
  }
`
